import { render, staticRenderFns } from "./aftersaleODM.vue?vue&type=template&id=538468b5&"
import script from "./aftersaleODM.vue?vue&type=script&lang=ts&"
export * from "./aftersaleODM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports